<div class="relative inline-block text-left w-full">
    <!-- Trigger Input/Button -->
    <div class="relative w-full" *ngIf="variant === 'standard'">
        <input type="text" [ngModel]="getInputValue()" (ngModelChange)="onInputChange($event)" (input)="onSearch()"
            (focus)="onInputFocus()" (blur)="onInputBlur()" (keydown)="onKeyDown($event)" [disabled]="disabled"
            [placeholder]="placeholder"
            class="w-full h-12 bg-white dark:bg-dark-tertiary border border-gray-300 dark:border-dark-border rounded-xl text-sm px-4 pr-10 shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-brand-primary disabled:bg-gray-100 dark:disabled:bg-dark-secondary disabled:cursor-not-allowed transition-colors duration-200 text-gray-900 dark:text-dark-text"
            [class.border-red-500]="hasError" />
        <button type="button" (click)="toggleDropdown()" [disabled]="disabled"
            class="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 hover:bg-gray-100 dark:hover:bg-dark-secondary rounded transition-colors duration-200">
            <svg class="h-4 w-4 text-gray-400 transition-transform duration-200" [class.rotate-180]="isOpen" fill="none"
                stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
        </button>
    </div>

    <!-- Text Trigger -->
    <div *ngIf="variant === 'text'" (click)="toggleDropdown()"
        class="cursor-pointer select-none inline-flex items-center gap-1 group" [ngClass]="customTextClasses">
        <span>{{ getDisplayText() }}</span>
    </div>

    <!-- Error Message -->
    <div *ngIf="hasError && errorMessage" class="mt-1 text-sm text-danger">
        {{ errorMessage }}
    </div>

    <!-- Dropdown Menu -->
    <div *ngIf="isOpen"
        class="fixed z-[9999] bg-white dark:bg-dark-secondary border border-gray-300 dark:border-dark-border rounded-md shadow-soft max-h-40 overflow-auto focus:outline-none"
        [style]="dropdownFixedStyle">

        <!-- Select All Checkbox (only for multiple selection) -->
        <div *ngIf="multiple && filteredItems.length > 0"
            class="px-4 py-2 border-b border-gray-200 dark:border-dark-border bg-gray-50 dark:bg-dark-tertiary">
            <div (click)="toggleSelectAll($event)"
                class="text-sm cursor-pointer transition-colors duration-150 flex items-center justify-between hover:bg-gray-100 dark:hover:bg-dark-secondary py-1 px-2 rounded">
                <span class="flex-1 font-medium text-gray-700 dark:text-dark-text">{{ TEXT.COMMON.SELECT_ALL }}</span>

                <!-- Select All Checkbox -->
                <div class="ml-2 flex-shrink-0">
                    <div class="w-4 h-4 border border-gray-300 rounded flex items-center justify-center transition-colors duration-150"
                        [class.bg-blue-500]="isAllSelected()" [class.border-blue-500]="isAllSelected()"
                        [class.bg-blue-200]="isPartiallySelected() && !isAllSelected()"
                        [class.border-blue-400]="isPartiallySelected() && !isAllSelected()">
                        <!-- Full selection checkmark -->
                        <svg *ngIf="isAllSelected()" class="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"></path>
                        </svg>
                        <!-- Partial selection dash -->
                        <svg *ngIf="isPartiallySelected() && !isAllSelected()" class="w-3 h-3 text-blue-600"
                            fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                                clip-rule="evenodd"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>

        <!-- Options List -->
        <div class="py-1">
            <div *ngFor="let item of filteredItems; trackBy: trackByFn" (click)="onItemClick(item)"
                class="px-4 py-2 text-sm cursor-pointer transition-colors duration-150 flex items-center justify-between"
                [class.bg-blue-50]="isSelected(item)" [class.text-blue-700]="isSelected(item)"
                [class.dark:bg-blue-900]="isSelected(item)" [class.dark:text-blue-100]="isSelected(item)"
                [class.bg-gray-50]="item.disabled" [class.text-gray-400]="item.disabled"
                [class.dark:bg-dark-secondary]="item.disabled" [class.dark:text-dark-muted]="item.disabled"
                [class.cursor-not-allowed]="item.disabled"
                [class.hover:bg-gray-100]="!item.disabled && !isSelected(item)"
                [class.dark:hover:bg-dark-tertiary]="!item.disabled && !isSelected(item)">
                <span class="flex-1 whitespace-nowrap text-gray-900 dark:text-dark-text"
                    [ngClass]="{'!text-blue-700 dark:!text-blue-100': isSelected(item), '!text-gray-400 dark:!text-dark-muted': item.disabled}">{{
                    item.label }}</span>

                <!-- Checkbox for multiple selection -->
                <div *ngIf="multiple" class="ml-2 flex-shrink-0">
                    <div class="w-4 h-4 border border-gray-300 rounded flex items-center justify-center"
                        [class.bg-blue-500]="isSelected(item)" [class.border-blue-500]="isSelected(item)">
                        <svg *ngIf="isSelected(item)" class="w-3 h-3 text-white" fill="currentColor"
                            viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"></path>
                        </svg>
                    </div>
                </div>

                <!-- Check icon for single selection -->
                <svg *ngIf="!multiple && isSelected(item)" class="w-4 h-4 text-blue-500 flex-shrink-0 ml-2"
                    fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"></path>
                </svg>
            </div>

            <!-- No results message -->
            <div *ngIf="filteredItems.length === 0" class="px-4 py-2 text-sm text-gray-500 dark:text-dark-muted">
                {{ TEXT.COMMON.NO_RESULTS }}
            </div>
        </div>
    </div>
</div>